import { Mail, FileText, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { buildPath } from '../routing';
import { normalizeLanguage } from '../i18n/utils';
import { resolvePrivacyPdfPath, resolveTermsPdfPath } from '../legalLinks';

export function Footer() {
  const { t, i18n } = useTranslation();
  const currentLang = normalizeLanguage(i18n.language);
  const featuresPath = buildPath(currentLang, 'features');
  const pricingPath = buildPath(currentLang, 'pricing');
  const downloadPath = buildPath(currentLang, 'download');
  const contactPath = buildPath(currentLang, 'contact');
  const privacyPdfPath = resolvePrivacyPdfPath(currentLang);
  const termsPdfPath = resolveTermsPdfPath(currentLang);

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/favicon.svg"
                alt="Noteon logo"
                className="size-6 rounded-md"
                loading="lazy"
              />
              <span className="text-white font-bold text-xl">Noteon</span>
            </div>
            <p className="text-gray-400 mb-4">
              {t('footer.description')}
            </p>
            <p className="text-sm text-gray-500">
              {t('footer.badge')}
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.product')}</h3>
            <ul className="space-y-2">
              <li>
                <a href={featuresPath} className="hover:text-teal-400 transition-colors">{t('footer.features')}</a>
              </li>
              <li>
                <a href={pricingPath} className="hover:text-teal-400 transition-colors">{t('footer.pricing')}</a>
              </li>
              <li>
                <a href={downloadPath} className="hover:text-teal-400 transition-colors">{t('footer.download')}</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t('footer.info')}</h3>
            <ul className="space-y-2">
              <li>
                <a href={privacyPdfPath} className="hover:text-teal-400 transition-colors flex items-center gap-2">
                  <Shield className="size-4" />
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href={termsPdfPath} className="hover:text-teal-400 transition-colors flex items-center gap-2">
                  <FileText className="size-4" />
                  {t('footer.terms')}
                </a>
              </li>
              <li>
                <a href={contactPath} className="hover:text-teal-400 transition-colors flex items-center gap-2">
                  <Mail className="size-4" />
                  {t('footer.contact')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            {t('footer.copyright')}
          </p>
          <p className="text-sm text-gray-500">
            {t('footer.tagline')}
          </p>
        </div>
      </div>
    </footer>
  );
}
